import { Box, Flex } from '@chakra-ui/react';

import { BrowserRouter as Router, Route, Routes, useLocation,Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react'; 

import TutorRouter from './TutorRouter';
import StudentRouter from './StudentRouter';
import AdminRouter from './AdminRouter';

import { TenantContextProvider, useTenant } from './TenantContextProvider';

import { jwtDecode } from "jwt-decode";

import { useToast } from "@chakra-ui/react";
import ChangePasswordStudent from '../Student/ChangePasswordStudent';
import ChangePasswordTutor from '../Tutor/ChangePasswordTutor';
import ChangePasswordAdmin from '../Admin/ChangePasswordAdmin';


import { Spinner, Center, Text } from "@chakra-ui/react";
import Login from '../Public/Login';
import TenantLanding from '../TenantLanding';
import EnrolmentPage from '../Public/EnrolmentPage';
import OnlineEnrolmentPage from '../Public/OnlineEnrolmentPage';



interface TokenData {
  sub: string;
  role_id: number;
  tenant_id: string;
  is_initial_password: boolean;
}


interface TenantPlatformRouterProps {
  onLogin: (newToken: string, refreshToken:string) => void;
  onLogout: () => void;
  isAuthenticated: boolean;
  setNavBarTenantInfo: (info: {
    tenantName: string;
    logoUrl: string;
    tenantSlug: string;
  }) => void;
}



// Utility function to decode token
const decodeToken = (token: string | null): TokenData | null => {
  try {
      return token ? jwtDecode<TokenData>(token) : null;
  } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
  }
};

const TenantPlatformRouter: React.FC<TenantPlatformRouterProps> = ({
  onLogin,
  onLogout,
  isAuthenticated,
  setNavBarTenantInfo
}) => {

    const navigate = useNavigate();
    const [token, setToken] = useState<string | null>(localStorage.getItem("token"));

    // Decode token to get the `is_initial_password` flag
    const decodedToken = decodeToken(token);
    const isInitialPassword = decodedToken?.is_initial_password ?? false;
   
    const roleId = decodedToken?.role_id;

          // Access tenant context
    const { tenant, loading, error } = useTenant();


      useEffect(() => {
        if (tenant) {
          setNavBarTenantInfo({
            tenantName: tenant.tenant_name,
            logoUrl: tenant.logo_url,
            tenantSlug: tenant.tenant_slug, // ✅ ADD THIS
          });
        }
      }, [tenant]);


          if (loading) {
           return (
          <Center minH="100vh">
            <Spinner size="xl" />
          </Center>
        );
      }
    
      if (error || !tenant) {
        return (
          <Center minH="100vh" flexDir="column">
            <Text fontSize="3xl" color="red.500">Tenant Not Found</Text>
            {/* <Navigate to="/404" replace /> */}
          </Center>
        );
      }
  
    return (

      
        <Box >
          <Routes>
            
            <Route path="/" element={<TenantLanding />} />
            {/* <Route path="login/" element={<Login onLogin={onLogin} />} />  */}
            <Route
            path="login/"
            element={
              isAuthenticated ? (
                <Navigate to="../app/" replace />
              ) : (
                <Login onLogin={onLogin} />
              )
            }
          />
            <Route path="enrol/" element={<EnrolmentPage />} />
            <Route path="enrol-online/" element={<OnlineEnrolmentPage />} />
            {/* Admin Routes */}
            {roleId === 2 && (
              <>
                
                <Route
                  path="/app/change-password"
                  element={
                    isAuthenticated ? (
                      <ChangePasswordAdmin handleLogout={onLogout} />
                    ) : (
                      <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />

                <Route
                  path="/app/*"
                  element={
                    isAuthenticated ? (
                      isInitialPassword ? (
                      <Navigate to={`/platform/${tenant.tenant_slug}/app/change-password`} replace />
                      ) : (
                        <AdminRouter />
                      )
                    ) : (
                      <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />
              </>
            )}

            {/* Tutor Routes */}
            {roleId === 3 && (
              <>
                <Route
                  path="/app/change-password"
                  element={
                    isAuthenticated ? (
                      <ChangePasswordTutor handleLogout={onLogout} />
                    ) : (
                      <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />
                <Route
                  path="/app/*"
                  element={
                    isAuthenticated ? (
                      isInitialPassword ? (
                        <Navigate to={`/platform/${tenant.tenant_slug}/app/change-password`} replace />
                      ) : (
                        <TutorRouter />
                      )
                    ) : (
                    <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />
              </>
            )}

            {/* Student Routes */}
            {roleId === 4 && (
              <>
              

                <Route
                  path="/app/change-password"
                  element={
                    isAuthenticated ? (
                      <ChangePasswordStudent handleLogout={onLogout} />
                    ) : (
                      <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />

                <Route
                  path="/app/*"
                  element={
                    isAuthenticated ? (
                      isInitialPassword ? (
                        <Navigate to={`/platform/${tenant.tenant_slug}/app/change-password`} replace />
                      ) : (
                        <StudentRouter />
                      )
                    ) : (
                      <Navigate to={`/platform/${tenant.tenant_slug}/login/`} replace />
                    )
                  }
                />
              </>
            )}
          </Routes>
      </Box>
      
    );
  };

export default TenantPlatformRouter;
